import { Message } from "../../../domain/model/Auth";
import { Game, UpdateGameRequestModel } from "../../../domain/model/Game";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { GameRepository } from "./GameRepository";

export class GameRepositoryImpl implements GameRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  update(
    model: UpdateGameRequestModel,
    gameId: string
  ): Promise<Response<Game>> {
    return this.apiService.updateGame(model, gameId);
  }
}
